import Section from "@/components/editorial/Section";
import Eyebrow from "@/components/editorial/Eyebrow";
import { EDITORIAL_IMAGES, STATS } from "@/data/content";

export default function WhatIs() {
  return (
    <Section tone="cream-dark" padding="xl" testid="what-is-section" id="about">
      <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-6 order-2 lg:order-1">
          <Eyebrow tone="terracotta" className="mb-5">
            Qué es Mujeres Motor
          </Eyebrow>
          <h2 className="font-serif font-light leading-[1.05] tracking-tight text-[clamp(2.25rem,4.5vw,4rem)]">
            Una plataforma<br />
            documental y<br />
            <span className="italic text-terracotta">comunidad viva.</span>
          </h2>
          <div className="mt-8 space-y-5 text-[17px] leading-relaxed text-charcoal/80 max-w-xl">
            <p>
              Producimos retratos editoriales de mujeres mexicanas que están
              transformando sus industrias, sus ciudades y sus comunidades.
              Cámara en mano, sin filtros corporativos.
            </p>
            <p>
              Las historias viajan entre documental, podcast, eventos y una
              red activa de mujeres que se conocen, se escuchan y se impulsan
              entre sí.
            </p>
            <p>
              Somos editorial porque creemos en el tiempo largo. Somos
              comunidad porque las historias, solas, no alcanzan.
            </p>
          </div>

          <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
            {STATS.map((s) => (
              <div key={s.label} data-testid={`stat-${s.label.toLowerCase().replace(/\s+/g, "-")}`}>
                <p className="font-serif font-light text-4xl md:text-5xl text-terracotta leading-none">
                  {s.value}
                </p>
                <p className="mt-2 text-[11px] uppercase tracking-[0.2em] text-charcoal/60">
                  {s.label}
                </p>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-6 order-1 lg:order-2">
          <div className="relative aspect-[4/3] overflow-hidden rounded-sm">
            <img
              src={EDITORIAL_IMAGES.production}
              alt="Ecosistema de producción de Mujeres Motor"
              loading="lazy"
              decoding="async"
              width="1536"
              height="1024"
              className="absolute inset-0 h-full w-full object-cover"
            />
            <div className="absolute inset-0 ring-1 ring-inset ring-charcoal/5" />
          </div>
        </div>
      </div>
    </Section>
  );
}
